import {
    observable,
    action,
    computed,
    toJS
} from 'mobx'

//const cookies = new Cookies();
class InternalStore {
    constructor() {
        this.initializeApp()
    }

    @observable route = {
        data: null,
        link: '',
        match: null,
    }

    @observable user = {
        logged: false,
        username: null,
        access_token: null,
        data: []
    };
    @observable loader = false;
    @observable headerTitle = "";
    @action setHeaderTitle = (title) => {
        this.headerTitle = title;
    }

    @observable actionDeleteObj = {
        module: null,
        id: null
    }
    @action setActionDeleteObj = (data) => {
        this.actionDeleteObj = data;
    }

    @observable actionDelete = false;
    @action setActionDelete = () => {
        this.actionDelete = !this.actionDelete;
    }

    @action setActionDeleteFalse = () => {
        this.actionDelete = false
    }

    @observable actionEdit = {
        edit: false,
        id: null
    };
    @action setActionEdit = (data) => {
        this.actionEdit = data
        this.getParentId(data.id)
    }

    @observable actionEdit2 = {
        edit: false,
        id: null
    };
    @action setActionEdit2 = (data) => {
        this.actionEdit2 = data
        this.getParentId(data.id)
    }



    @observable administrators = [];
    @action setAdministrators = (data) => {
        this.administrators = data;
    }


    @observable successUpdatePhoto = null;
    @action photoWasChanged = (data) => {
        this.successUpdatePhoto = data;
    }

    @observable basicInfoAdministrator = [];


    @action showLoader = () => {
        this.loader = true
    }
    @action hideLoader = () => {
        this.loader = false
    }
    @action setBasicInfoAdministrator = (data) => {
        //this.basicInfoAdministrator.push(data);
        this.basicInfoAdministrator = data;
    }

    @observable dataSnackbar = {
        msg: "",
        open: false,
        error: false
    };
    @action setSnackbar = (msg, state, error = false, timeout = 3000) => {
        this.dataSnackbar.msg = msg;
        this.dataSnackbar.open = state;
        this.dataSnackbar.error = error;
        this.turnOffSnackbar(timeout);
    }

    turnOffSnackbar(timeout = 3000) {
        let data = {
            msg: "",
            open: false,
            error: false
        };
        clearTimeout(this.timeout)
        this.timeout =  setTimeout(() => {
            this.dataSnackbar = data
        }, timeout)
    }

    @observable administrator = [];
    @action changeAdministratorData = (prop, value) => {
        this.administrator[prop] = value;
    }

    @observable dataForTable = [];
    @action setDataForTable = (data) => {
        this.dataForTable = data;
    }

    @action setResultDataForTable = (data) => {
        this.dataForTable.data = data
    }

    //CustomTableSimple
    @observable dataForSimpeTable = [];
    @action setDataForSimpeTable = (data) => {
        this.dataForSimpeTable = data;
    }

    @action getParentsFromTable() {
        let parents = []
        for(let i=0;i<this.dataForTable.length; i++) {
            if(this.dataForTable[i].name) {
                parents[i] = this.dataForTable[i].name
            }
        }
        return parents;
    }

    @observable listCategories = [{}];
    @action pushCategoryToList = (data) => {
        this.listCategories.push(data);
    }
    @action resetCatelogyToList = () => {
        this.listCategories = [{}];
    }

    @observable parents = [{}]
    @action resetParents() {
        this.parents = []
    }
    @action pushParentToParents = (data)=> {
        // this.parents = []
        this.parents.push(data);
    }

    @observable parent_id = 0;
    @action getParentId = (id) => {
        if(id) {
            let parent = this.parents.filter(i => i.id === id)
            if(parent[0]) {
                this.parent_id = toJS(parent[0].parent_id)
            }

        }

    }

    @observable checkedRows = [];
    @action resetCheckedRows = () => {
        this.checkedRows = []
    }
    @action setCheckedRows = (rows) => {
        this.checkedRows = rows;
    }

    @observable numberOfItemsInShopingCart = 0;
    @action updateNumberOfItemsInShopingCart = (numItems) => {
        this.numberOfItemsInShopingCart = numItems;
    }

    @observable allDataFromShoppingCart = {}
    @action setAllDataFromShoppingCart = (data) => {
        this.allDataFromShoppingCart = data;
    }

    @observable shoppingCart = [];
    @action addToShoppingCart = (item) => {
        // let itemIsInCart = false;
        // for(let i=0; i< this.shoppingCart.length; i++) {
        //     if(item.id === this.shoppingCart[i].id) {
        //         this.shoppingCart[i].count += item.count
        //         itemIsInCart = true;
        //     }

        // }

        // if(!itemIsInCart) {
        //     this.shoppingCart.push(item);
        // }
        this.shoppingCart = item

    }

    @observable parent = {}
    @action setParent = (id) => {
        this.parent = this.parents.filter(data => data.id=== id);
    }

    @observable children = []
    @action getChildrensInParent = (id) => {
        this.children = this.parents.filter(data => data.parent_id === id);
        return this.children;
    }

    @action changeDataForSimpeTable = (prop, value) => {
        this.dataForSimpeTable[prop] = value;
    }

    @action changeAdministratorClients = (list) => {
        this.dataForSimpeTable.clients_list = list;
    }


    @action setOneAdministrator = (data) => {
        this.administrator = data;
    }



    @observable init = false;

    @observable data = {
        url: '/',
    };

    @action pushRoute = (str, state = null) => {
        if (this.route.data) {
            this.route.data.push(str, state)
            this.route.link = str;
        } else {
            alert('not defined route')
        }
    }

    @action setRoute = (hist, link, match = null) => {
        if (link) {
            this.route.link = link;
        }
        if (match)
            this.route.match = match
        this.route.data = hist
    }

    @action initializeApp = () => {
        this.getUserData()
        this.init = true;

        setInterval(() => {
            const lastUserAction = localStorage.getItem('lastUserAction') || 0;
            if (lastUserAction < Date.now() - 4 * 60 * 60 * 1000) { // 4 hours
                this.logout()
            }
        }, 90 * 1000); // every minute and half
    }

    @action changeUrl(url) {
        this.data.url = url;
    }

    @action getUserData = () => {
        let user = localStorage.getItem('user')
        if (user && user.access_token) {
            this.user = user;
        }

    }
    @action logout = (data) => {
        this.user.logged = false;
        //this.user.username = null;
        this.user.access_token = null;
        this.user.data = [];
        //cookies.set('user', toJS(this.user));
        // cookies.set('user', null);
        //cookies.remove('user')

    }
    @action loginUser = (data, logged) => {
        for (let prop in data) {
            if (this.user[prop] !== null || this.user[prop] !== false) {
                this.user[prop] = data[prop]
            }
        }
        this.user.logged = logged;
    }

    @observable notificationsId = [];
    @action setNotifications = (ids) => {
        this.notificationsId = ids;
    }
    @action setReadNotification = (id) => {
        // let newNotificationsForRead = this.notificationsId.filter(function(data) {
        //     if(data !== id) {
        //         return data
        //     }
        // })
    }

    @observable loader = {
        loading: false,
        id: null
    };
    @action setLoader = (data) => {
        this.loader = data;
    }

    @observable notifiId = null;
    @action setNotiifiId = (id) => {
        this.notifiId = id;
    }

    @observable clientNote = "";
    @action setClientNote = (note) => {
        this.clientNote = note;
    }

    @observable clientOrderNumber = "";
    @action setClientOrderNumber = (orderNumber) => {
        this.clientOrderNumber = orderNumber;
    }

    @observable clientDeliveryDate = null;
    @action setClientDeliveryDate = (deliveryDate) => {
        this.clientDeliveryDate = deliveryDate;
    }

    @action updateUser = (data) => {
        for (let prop in data) {
            // let value = toJS(this.user.data[prop])
            this.user.data[prop] = data[prop];
        }
    }

    @observable activeTab = 0;
    @action setActiveTab = (tab) => {
        this.activeTab = tab;
        // this.pushRoute("/")
        this.pushRoute("/test/"+toJS(this.subheader.tabs[tab].slug))
    }

    // ukladame vsetky produkty - pouzite v moduloch [top-products]
    @observable allProducts = [];
    @action setAllProducts = (data) => {
        this.allProducts =  data;
    }

    @observable subheader = {
        title: null,
        tabs: []
    }
    @action setSubheaderTitle = (title) => {
        this.subheader.title = title;
    }
    @action setSubheaderTabs = (tabs) => {
        this.subheader.tabs = tabs;
    }


    @observable backToShoppingCart = false;
    @action setBackToShoppingCart(status) {
        this.backToShoppingCart = status
    }

    @observable backToOrderDetail = null;
    @action setBackToOrderDetail(url) {
        this.backToOrderDetail = url
    }

    @observable staticPages = null;
    @action setStaticPages(pages) {
        this.staticPages = pages
    }

    @computed
    get getFulllName() {
        return this.user.username
    }

    @action changeName = (name) => {
        this.user.username = name;
    }

    @observable lastVisitedPage = null
    @action setLastVisitedPage = (url) => {
        this.lastVisitedPage = url;
    }

    @observable countries = []
    @action setCountries = (countries) => {
        this.countries = countries;
    }
}

const internalStore = new InternalStore()
export default internalStore



// WEBPACK FOOTER //
// ./src/stores/internal.js